import { Card, CardContent } from "@/components/ui/card";
import { X, Plus, RefreshCcw } from "lucide-react";
import { PoContractUpdateSimulationProps } from "./po-contract-update-simulation.types";

export const PoContractUpdateSimulation = ({
  toCreate = {
    count: 0,
    hasProRata: false,
  },
  toUpdate = {
    count: 0,
  },
  toCancel = {
    count: 0,
  },
}: PoContractUpdateSimulationProps) => {
  return (
    <Card className="flex bg-slate-50 mt-2">
      <CardContent className="inline-flex gap-8 w-full p-4">
        {toCreate.count > 0 && (
          <div className="flex-1 inline-flex flex-col">
            <div className="mt-2 mb-2 px-2.5 py-0.5 bg-green-500 rounded-full inline-flex gap-1 max-w-[72px]">
              <Plus className="w-4 h-4 flex-shrink-0 text-white" />
              <div className="justify-center text-white text-[10px] font-semibold leading-tight py-0.5">
                Criado
              </div>
            </div>
            <div className="flex-1 inline-flex flex-col mb-2">
              <div className="self-stretch justify-start text-foreground text-lg font-medium leading-relaxed">
                {toCreate.count} Bookings serão criados
              </div>
              {toCreate.hasProRata && (
                <div className="self-stretch justify-start text-muted-foreground text-sm font-normal leading-tight">
                  1 Booking com pro rata.
                </div>
              )}
            </div>
          </div>
        )}
        {(toCancel.count > 0 || toUpdate.count > 0) && !!toCreate.count && (
          <div className="w-px self-stretch bg-border border" />
        )}
        {toCancel.count > 0 && (
          <div className="flex-1 inline-flex flex-col">
            <div className="mt-2 mb-2 px-2.5 py-0.5 bg-red-500 rounded-full inline-flex gap-1 max-w-[96px]">
              <X className="w-4 h-4 flex-shrink-0 text-white" />
              <div className="justify-center text-white text-[10px] font-semibold leading-tight py-0.5">
                Cancelado
              </div>
            </div>
            <div className="flex-1 inline-flex flex-col mb-2">
              <div className="self-stretch justify-start text-foreground text-lg font-medium leading-relaxed">
                {toCancel.count} Bookings serão Cancelados
              </div>
            </div>
          </div>
        )}
        {!!toUpdate.count && !!toCancel.count && (
          <div className="w-px self-stretch bg-border border" />
        )}
        {toUpdate.count > 0 && (
          <div className="flex-1 inline-flex flex-col">
            <div className="mt-2 mb-2 px-2.5 py-0.5 bg-orange-500 rounded-full inline-flex gap-1 max-w-[96px]">
              <RefreshCcw className="w-4 h-4 flex-shrink-0 text-white" />
              <div className="justify-center text-white text-[10px] font-semibold leading-tight py-0.5">
                Modificado
              </div>
            </div>
            <div className="flex-1 inline-flex flex-col mb-2">
              <div className="self-stretch justify-start text-foreground text-lg font-medium leading-relaxed">
                {toUpdate.count} Bookings serão atualizados
              </div>
              <div className="self-stretch justify-start text-muted-foreground text-sm font-normal leading-tight">
                Com base no resumo de edições
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
